import React from 'react';
import { Label } from 'semantic-ui-react';

export function StatusLabel({ status }: { status: 'Enabled' | 'Disabled' }) {
  return (
    <Label color={status === 'Enabled' ? 'olive' : 'grey'}>{status}</Label>
  );
}
